import { ReceiptSettings, ReceiptSettingsType, TimeTrackingMode } from "./ReceiptSettings";
import dayjs from "dayjs";

export class DeliveryNoteSettings extends ReceiptSettings {
    public timeTrackingMode: TimeTrackingMode;
    public content: NoteContentSettings;
    public type = ReceiptSettingsType.DELIVERY_NOTE;

    constructor(initialValues?: Partial<DeliveryNoteSettings>) {
        super(initialValues);
        this.timeTrackingMode = initialValues?.timeTrackingMode ?? TimeTrackingMode.COMPACT;
        this.prefix = initialValues?.prefix ?? `LI-${dayjs().year()}`;
        this.content = initialValues?.content ?? DEFAULT_NOTE_CONTENT_SETTINGS;
    }
}

export interface NoteContentSettings {
    showMachineCounters: boolean;
    showMachineName: boolean;
    showEmployeeNames: boolean;
    showOrderStartStopTimes: boolean;
    showOnExport: boolean;
}

export const DEFAULT_NOTE_CONTENT_SETTINGS: NoteContentSettings = {
    showMachineCounters: false,
    showMachineName: false,
    showEmployeeNames: false,
    showOrderStartStopTimes: false,
    showOnExport: false,
};
